export default "__VITE_ASSET__Dvk6Gu55__"